<template>
  <div class="shopSelect">
    <div class="shopTitle">
      <span>请选择要查看数据的商家</span>
    </div>
    <div class="scrollBody" ref="scrollBody">
      <ul class="contentUl" >
        <li class="contentLI"  v-for="(item, index) in merchantIdList" :key="index">
          <div class="radioDiv">
            <!-- :checked="index ===0"  -->
            <input type="radio" :checked= "index === 0" :id="item.merchangId" v-model="radioVal" :value="item" name="shopSelectRadio">
          </div>
          <div class="labelDiv">
            <label class="titleLabel" :for="item.merchangId">{{item.merchantName}}</label>
          </div>
        </li>
      </ul>
    </div>
    <div class="confirmDiv" @click.prevent="confirmFn">
      确定
    </div>
   
  </div>

</template>
<script>
import BScroll from 'better-scroll'
import Common from 'common/js/common'
import { MessageBox } from 'mint-ui'
export default {
  data() {
    return {
      radioVal: this.common.localGet('merchantIdList')[0],
      merchantIdList: this.common.localGet('merchantIdList')
    }
  },
  methods: {
    initScroll() {
      this.$nextTick(() => { // this.$nextTick(() => {})判断dom结构是否完全加载，click: true属性用来设置可以进行点击事件
        this.scroll = new BScroll(this.$refs.scrollBody, {
          click: true
        })
      }
    )
    },
    confirmFn() {
      const _this = this
      this.$http.get(Common.url_user + '/managerH5BindMerchant', {
        params: {
          openId: Common.localGet('openId'),
          userId: this.radioVal.userId,
          merchantId: this.radioVal.merchangId
        }
      })
      .then(function(response) {
        console.log(JSON.stringify(response))
        if (response.data.code === 0) {
          _this.common.localSet('loginInfo', response.data.data)
          _this.$router.push({ path: '/dataDisplay' })
        } else if (response.data.code === 300008) {  // 取消权限或被迫下线
          MessageBox.confirm('', {
            message: response.data.msg,
            title: '提示',
            confirmButtonText: '确定',
            showCancelButton: false
          }).then(action => {
            if (action === 'confirm') {
              _this.$router.push({ path: '/login' })
            }
          })
        } else {
          MessageBox.confirm('', {
            message: response.data.msg,
            title: '提示',
            confirmButtonText: '确定',
            showCancelButton: false
          }).then(action => {
            if (action === 'confirm') {
              console.log(response.data.msg)
            }
          })
        }
      })
      .catch(function(error) {
        // _this.$toast.log('错误的请求' + error)
        _this.$toast(error)
      })
    }
  }
}
</script>
<style scoped>
  .shopSelect{
    width: 100%;
    height: 100%;
    padding-top: 1.1rem;
    background-color: #f1f2f3;
  }
  .shopTitle{
    position: fixed;
    top: 0;
    width: 100%;
    height: 0.9rem;
    padding-left: 0.28rem;
    background-color: #ffffff;
    line-height: 0.9rem;
  }
  .shopTitle span{
    font-size: 0.28rem;
    color: #000000;
    font-weight: bold;
  }
  .scrollBody {
    margin-bottom: 1.18rem;
    background-color: #f1f2f3;
  }
   
  .contentUl{
    width :100%;
    display :flex;
    flex-direction:column;
    align-items:center;
  }
  .contentLI{
    width :100%;
    min-height :0.9rem;
    display: flex;
    align-items: center;
    padding: 0 0.28rem;
    background-color :#ffffff;
  }
  .contentLI:not(:last-child){
    border-bottom: 1px solid #f1f2f3
  }
  .confirmDiv{
    width: 100%;
    height: 1.18rem;
    line-height: 1.18rem;
    font-size: 0.32rem;
    color: #ffffff;
    text-align: center;
    background-color: #f74d47;
    position: fixed;
    bottom: 0;
  }

  .noConfirmDiv {
    width: 100%;
    height: 1.18rem;
    line-height: 1.18rem;
    font-size: 0.32rem;
    color: #ffffff;
    text-align: center;
    background-color: #CCCCCC;
    position: fixed;
    bottom: 0;
  }
  input[name='shopSelectRadio']{
    width : 0.35rem;
    height : 0.34rem;
    vertical-align: sub;
    outline: none;
    border-radius :12px;
    -webkit-appearance : none;
    -moz-appearance : none;
    appearance : none;
    background: url('~common/image/radioBlack.png');
    background-size :0.35rem 0.34rem;
    background-repeat :no-repeat;
  }
  input[name='shopSelectRadio']:checked {
    width : 0.35rem;
    height: 0.34rem;
    outline: none;
    -webkit-appearance : none;
    -moz-appearance : none;
    appearance : none;
    background: url('~common/image/radioSelect.png');
    background-size :0.35rem 0.34rem;
    background-repeat :no-repeat;
   }
  .titleLabel{
    font-size :0.28rem;
    color :#000000;
    width: 1.3rem;
    height: 0.8rem;
    line-height: 0.4rem;
    }
  .radioDiv{
    display: inline-block;
    margin-right: 0.3rem;
  }
  .labelDiv{
    padding: 0.2rem 0;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/shopSelect.vue